import React, {useEffect, useState} from 'react';
import {
    Card,
    CardHeader,
    CardContent,
    Divider,
    Collapse,
    TableRow,
    TableCell,
    Button, Link,
} from '@material-ui/core';
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import {Skeleton} from "@material-ui/lab";
import useAdminUserSession from "../../../../hooks/useAdminUserSession";
import SortableTable from "../../shared/Tables/SortableTable";
import PieceOfNewsForm from "../../news/PieceOfNewsForm";
import CustomSnackbar from "../../../user/shared/CustomSnackbar";
import MATransactionService from "../../services/MATransactionService";

const MATransactionNews = ({transaction, open, fetchNews, fetching, hasChanges, newsTypes, riaInvestorParents, ...props}) => {
    const {session} = useAdminUserSession();

    const [expandNews, setExpandNews] = useState(open);
    const [openAddNewsForm, setOpenAddNewsForm] = useState(false)
    const [selectedPieceOfNewsId, setSelectedPieceOfNewsId] = useState(null);
    const [selectedTransaction, setselectedTransaction] = useState(transaction);
    const [news, setNews] = useState([]);
    const [showSnackBar, setShowSnackBar] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState('');

    useEffect(() => {
        setNews(props.news);
    }, [props.news])

    const toggleExpandNews = () => {
        setExpandNews(!expandNews);
    }

    const onCloseModal = (piece_of_news, itemIndex) => {
        setOpenAddNewsForm(false)
    }

    const onNewPieceOfNews = () => {
        setselectedTransaction(transaction);
        setSelectedPieceOfNewsId(undefined);
        setOpenAddNewsForm(true);
    }

    const onEditNews = (news_to_edit) => {
        setselectedTransaction(transaction);
        setSelectedPieceOfNewsId(news_to_edit.id);
        setOpenAddNewsForm(true);
    }

    const onRemoveNews = (news_to_remove) => {
        if (window.confirm("Are you sure you want to remove this news from the transaction?")) {
            MATransactionService.updateNews(transaction.id, session, {...news_to_remove, remove: true}).then(() => {
                setNews(news.filter(news_item => news_item.id !== news_to_remove.id));
                setSnackBarMessage('News removed successfully');
                setShowSnackBar(true);
            })
        }
    }

    const onCloseModalAfterAction = (newItem) => {
        onCloseModal();
        fetchNews();
        setSnackBarMessage(newItem ? 'News created successfully' : 'News updated successfully');
        setShowSnackBar(true);
    }

    return (
        <React.Fragment>
            <Card style={{marginTop: '24px'}}
            >
                <CardHeader className='cursor-pointer' title={
                    <span>
              <span>Related News</span>
              <span className='float-right'>
                {
                    expandNews ? <ExpandLess/> : <ExpandMore/>
                }
              </span>
            </span>
                } onClick={toggleExpandNews}
                />
                <Divider/>
                <CardContent style={{padding: `${expandNews ? '20px' : 0}`, overflowY: 'auto'}}>
                    <Collapse in={expandNews}>
                        {
                            fetching ? <Skeleton animation='pulse' variant='rect' height='100px' width='100%' component='div'/> : <SortableTable
                                headCells={[
                                    {id: 'title', numeric: false, disablePadding: false, label: 'Title', sortable: true},
                                    {id: 'name', numeric: false, disablePadding: false, label: 'Publisher', sortable: true},
                                    {id: 'date', numeric: false, disablePadding: false, label: 'Written', sortable: true},
                                    {id: 'type', numeric: false, disablePadding: false, label: 'Type'},
                                    {id: 'sources', numeric: false, disablePadding: false, label: 'Sources'},
                                    {id: 'edit', numeric: false, disablePadding: false, label: ''},
                                    {id: 'delete', numeric: false, disablePadding: false, label: ''},
                                ]}
                                rows={news}
                                RowRenderer={
                                    (row, _isSelected, index, _handleCheck) => (<TableRow
                                        hover
                                        tabIndex={-1}
                                        key={row.id}
                                        style={{cursor: "pointer"}}
                                        onClick={(event) => (row.id)}
                                    >
                                        <TableCell>
                                            <Link href={row.source_url} target={'_blank'} disabled={transaction?.status === 'rejected'}>{row.title}</Link>
                                        </TableCell>
                                        <TableCell>
                                            {row.extra_data?.publisher?.name}
                                        </TableCell>
                                        <TableCell>
                                            {row.written_at}
                                        </TableCell>
                                        <TableCell>
                                            {row.extra_data?.news_type}
                                        </TableCell>
                                        <TableCell>
                                            {Array.isArray(row.sources) ? row.sources.join(', ') : (row.source || '')}
                                        </TableCell>
                                        <TableCell>
                                            <Link to='' onClick={() => onEditNews(row)} disabled={!props.canEdit}>Edit</Link>
                                        </TableCell>
                                        <TableCell>
                                            {row.transaction_ids?.length === 1 && <Link to='' onClick={() => onRemoveNews(row)} disabled={!props.canEdit}>Delete</Link>}
                                        </TableCell>
                                    </TableRow>)
                                }
                            />
                        }
                        <Button
                            className={'colored-element create'}
                            variant="contained"
                            onClick={onNewPieceOfNews}
                            style={{marginBottom: "10px", marginTop: "10px"}}
                            disabled={!props.canEdit}
                        >
                            Add News
                        </Button>
                    </Collapse>
                </CardContent>
            </Card>

            {openAddNewsForm ?
                <PieceOfNewsForm
                    adminUserSession={session}
                    pieceOfNewsId={selectedPieceOfNewsId}
                    newsTypes={newsTypes}
                    onClose={() => setOpenAddNewsForm(false)}
                    open={openAddNewsForm}
                    afterCreatePieceOfNews={() => onCloseModalAfterAction(true)}
                    onDataUpdate={() => onCloseModalAfterAction(false)}
                    fixedTransaction={selectedTransaction}
                    itemIndex={selectedPieceOfNewsId || 0}
                    riaInvestorParents={riaInvestorParents}
                />
                : null
            }

            {showSnackBar &&
                <CustomSnackbar
                    open={showSnackBar}
                    closeHandler={() => setShowSnackBar(false)}
                    message={snackBarMessage}
                    options={{
                        severity: 'success'
                    }}
                />
            }
        </React.Fragment>
    )
}

export default MATransactionNews;